module.exports = __webpack_public_path__ + "static/media/Museo700-Regular.dc579f97.otf";